import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Apple, Google } from '../../ui/icons';
import styled from 'styled-components';
import Modal from '../../components/Modal/Modal';
import { useTranslation } from 'react-i18next';

const Input = styled.input`
  padding: 12px 16px; 
  border-radius: 12px;
  font-size: 14px;
  color: #1C1B1F;
`;

const TextLink = styled.span`
  font-size: 15px;
  font-weight: 600;
  border-bottom: 1px solid #FFF;
`;

const Button = styled.button`
  width: 48%;
  padding: 16px 0;
  background: #F0F0F0;
  justify-content: center;
  border-radius: 12px;
  display: flex;
  @media(max-width: 1032px) {
    width: 80%;
  }
`;

const Wrapper = styled.div`
  @media(max-width: 1032px) {
    flex-direction: column;
    gap: 10px;
  } 
`;

const Forget = () => {
    const { t } = useTranslation();
    const [submit, setSubmit] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const onFinish = (e) => {
        e.preventDefault();
        if (!formData.email || !formData.password) {
            alert(t('auth.fill_all_fields'));
            return;
        }
        setSubmit(true);
    };

    const styles = {
        img: {
            height: "calc(100vh - 74px)",
            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.61), rgba(0, 0, 0, 0.61)), url('./images/Main/Background.png')",
            backgroundSize: "cover",
            backgroundPosition: "center"
        },
    };

    return (
        <section style={styles.img}>
            <div className='px-6 py-10 flex flex-col items-center justify-center text-[#FFF] text-center bg-[#0A1F44C7]'>
                <p className='uppercase font-light'>{t('auth.start_for_free')}</p>
                <h2 className='font-medium text-3xl py-4'>{t('auth.welcome')}</h2>
                <p className='text-base'>
                    {t('auth.no_account')}{' '}
                    <Link to='/signup' className='text-[#FFF]'>
                        <TextLink>{t('auth.sign_up')}</TextLink>
                    </Link>
                </p>
                <form onSubmit={onFinish} className="flex flex-col gap-5 pt-6 w-full sm:w-2/5">
                    <Input
                        type="email"
                        name="email"
                        placeholder={t('auth.email_placeholder')}
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <Input
                        type="password"
                        name="password"
                        placeholder={t('auth.password_placeholder')}
                        value={formData.password}
                        onChange={handleChange}
                    />
                    <p className='text-right'>
                        <Link to='/forgot' className='text-[#C6A982]'>
                            {t('auth.forgot_password')}
                        </Link>
                    </p>
                    <button type='submit' className='py-3 bg-[#C6A982] rounded-xl'>
                        {t('auth.sign_in')}
                    </button>
                    <div className='flex items-center gap-3 justify-between opacity-50'>
                        <hr className='text-[#FFFFFF] w-1/4 sm:w-2/6' />
                        <p className='sm:text-base text-sm'>{t('auth.or_sign_in_with')}</p>
                        <hr className='text-[#FFFFFF] w-1/4 sm:w-2/6' />
                    </div>
                    <Wrapper className='flex justify-between items-center'>
                        <Button>
                            <Google />
                        </Button>
                        <Button>
                            <Apple />
                        </Button>
                    </Wrapper>
                </form>

                <Modal submit={submit} />
            </div>
        </section>
    );
};

export default Forget;